import React from "react";
import salaryStyle from "@/components/Dialog/RewardsExplained/index.module.scss";
import tierStyle from "@/components/Dialog/TiersExplained/index.module.scss";
import warpath from "@/assets/images/warpath_logo.png";
import dislyte from "@/assets/images/dislyte_logo.png";
import afk from "@/assets/images/afk.png";
import afk2 from "@/assets/images/afk2.png";
import aoc from "@/assets/images/aoc.png";
import rok from "@/assets/images/rok.png";
import COD from "@/assets/images/samo_logo.png";
import farlight84 from "@/assets/images/farlight84.png";

import DislyteTierTable from "@/components/Dialog/TiersExplained/dislyteTable";
import Fl84TierTable from "@/components/Dialog/TiersExplained/fl84Table";

const DislyteExplained = () => (
  <div className={salaryStyle.desc}>
    <p>The Dislyte TV Program features two types of reward systems applicable to creators from all three tiers. All creators will be eligible to receive rewards depending on the corresponding level which their creations fall into. Your level will be determined by video views and given that all Dislyte-related content made is 100% the Creator&apos;s own original work. </p>
    <p className={salaryStyle.t1}>Monthly Total View-based Rewards </p>
    <p>Monthly total view-based rewards take all Dislyte-related videos published in a certain month into account. Creators are awarded rewards based on different levels set for various amounts of video views. When a Creator reaches a certain level for 3 consecutive months, the Creator will qualify for an opportunity to sign a long-term contract with Farlight Games</p>
    <p className={salaryStyle.t1}>Task View-based Rewards</p>
    <p>Task view-based rewards are based on one exact video with specific task requirements for the task which will be set by the Staff. The exact reward differs per level and will be determined according to your task&apos;s performance.</p>
  </div>
);

const WarpathExplained = () => (
  <div className={salaryStyle.desc}>
    <p className={salaryStyle.t1}>In-game and montary benefits will be distributed through the following channels.</p>
    <p>1. In-game rewards: Directly mailed through in-game.</p>
    <p>2. Cash: Bank transfer to your provided bank account.</p>
    <p>3. CDK: Currently CDKs are not offered as rewards to Creators.</p>
  </div>
);

const CODExplained = () => (
  <div className={salaryStyle.desc}>
    <p>Once you are above the Apprentice tier, you are eligible for monetary compensation based on your tier and performance. Each tier has its own range of monetary benefits. Once all formal processes are done, monetary benefits will be distributed through a bank transfer to your provided bank account.</p>
  </div>
);

const Farlight84Explained = () => (
  <div className={salaryStyle.desc}>
    <p>1. All views are calculated and based on natural and organic views shown on your channel. (Multiple platforms will be calculated separately)</p>
    <p>2. View tools (tools that increase views) are prohibited; we encourage free and natural creation. (If view tools are detected, you might not be able to get the reward according to the standard. )</p>
    <p>3. For FCC who reaches Cash Reward tier, you must have a valid bank account to proceed with the reward sending. (Currently only bank transfer is supported)</p>
    <p>4. Calculating will be done and rewards be sent within the first 10 days of next month. (for example, Rewards for March will be issued between April 1st to 10th); Cash rewards within 15 days varying on different banks.</p>
    <p>5. The standard for long videos(streams) and short videos will be calculated separately.</p>
  </div>
);

const ROKExplained = () => (
  <div className={salaryStyle.desc}>
    <p>In-game and montary benefits will be distributed through the following channels.</p>
    <p>&nbsp;</p>
    <p>1. In-game rewards: Directly mailed through in-game or sent through discord with a giftcode.</p>
    <p>2. Cash: Bank transfer to your provided bank account.</p>
  </div>
);

// 星级描述 
const DislyteTierExplained = () => (
  <div className={tierStyle.desc}>
    <p className={tierStyle.t1}>Tier Perks Explained</p>
    <p>Apprentice Tier:</p>
    <p>- Invitation to our exclusive video content creator Discord Server</p>
    <p>- Exclusive ticket system on the Creator Discord server to receive 1 on 1 help from the staff</p>
    <p>- Access to official art assets to help you create your content</p>
    <p>- The possibility to get in-game rewards and/or monetary compensation</p>

    <p>Associate Tier:</p>
    <p>- All perks in Apprentice Tier</p>
    <p>- The possibility to have your content featured on our official social media platforms</p>

    <p>Partner Tier:</p>
    <p>- All Perks in previous tiers</p>
    <p>- Customized gift codes used for giveaways to your viewers</p>
    <p>- The possibility to get invited to official Dislyte events</p>
    <p>- The possibility of co-creating content with the Dislyte Team</p>


    <p className={tierStyle.t1}>How do we determine tiers and how can a Content Creator advance in tiers</p>
    <p>Apprentice:</p>
    <p>- All Creators will start in the Apprentice Tier.</p>
    <p>- Creators can advance to the Associate tier after publishing more than 10 Dislyte-related videos per month for 3 consecutive months. </p>

    <p>Associate:</p>
    <p>- Creators can advance to the Partner tier after publishing more than 10 Dislyte-related videos per month for 3 consecutive months after joining the Associate tier. </p>
    <p>- Creators who published less than 10 videos in the previous month will be demoted back to the Apprentice Tier.</p>

    <p>Partner:</p>
    <p>- Creators who have successfully met previous requirements from the Apprentice and Associate tiers will get promoted to the Partner Tier. </p>
    <p>- Creators who produced less than 10 videos in the current month will get demoted back to the Associate tier.</p>

    <p>*Creators who haven’t posted any content for 2 consecutive months will be temporarily removed from the program. </p>

    <p className={tierStyle.t1}>Rewards Explained</p>
    <p>The Dislyte TV Program features two types of reward systems applicable to creators from all three tiers. All creators will be eligible to receive rewards depending on the corresponding level which their creations fall into. Your level will be determined by video views and given that all Dislyte-related content made is 100% the Creator&apos;s own original work. </p>
    <p>Monthly Total View-based Rewards </p>
    <p>Monthly total view-based rewards take all Dislyte-related videos published in a certain month into account. Creators are awarded rewards based on different levels set for various amounts of video views. When a Creator reaches a certain level for 3 consecutive months, the Creator will qualify for an opportunity to sign a long-term contract with Farlight Games</p>
    <p>Task View-based Rewards</p>
    <p>Task view-based rewards are based on one exact video with specific task requirements for the task which will be set by the Staff. The exact reward differs per level and will be determined according to your task&apos;s performance.</p>

    <DislyteTierTable />
  </div>
);

const WarpathTierExplained = () => (
  <div className={tierStyle.desc}>
    <p className={tierStyle.t1}>How do we determine tiers?</p>
    <p>Tiers are mainly determined by the number of subscribers, content quality, community appreciation, and relevance to the game. All Creators will be reviewed and assigned after being thoroughly reviewed by the Staff.</p>

    <p className={tierStyle.t1}>What perks/advantages are related to each tier?</p>
    <p>All tiers have access to the Creators Discord, Staff Help, and Art assets. Associate Creators receive additional early sneak peeks and content promotion. Partnered Creators receive all perks mentioned before, and invitations to official events/content and monetary compensations.</p>

    <p className={tierStyle.t1}>How can Creators rank up in Tier?</p>
    <p>Creators can work on their subscribers, content quality, community appreciation, and content relevance to improve their chances to rank up a tier. The Staff will periodically review content creators to see if they are eligible for a promotion.</p>
  </div>
);

// COD-英文
const CODTierExplained = () => (
  <div className={tierStyle.desc}>
    <p className={tierStyle.t1}>Summary:</p>
    <p>As a content creator, you will receive small in-game rewards, have the potential to have your content featured on our channels and in-game, access to the Creator Discord Channel, exclusive sneak peeks, early update previews, and monetary compensation. </p>
    <p className={tierStyle.t1}>Apprentice:</p>
    <p>As an Apprentice content creator, you will receive:</p>
    <p>Access to the Creator Discord Channel</p>
    <p>Access to art assets</p>
    <p>Official support</p>
    <p>The possibility of receiving small in-game rewards or monetary compensation for your contributions</p>
    <p className={tierStyle.t1}>Associate:</p>
    <p>In the Associate tier, you will receive:</p>
    <p>All of the benefits of the Apprentice tier</p>
    <p>Exclusive sneak peeks</p>
    <p>Monetary compensation</p>
    <p>Official promotion of your channel</p>
    <p className={tierStyle.t1}>Partner:</p>
    <p>As a Partner content creator, you will receive:</p>
    <p>All of the benefits of the previous tiers</p>
    <p>Early update previews</p>
    <p>The potential for your content to be featured on our channels and in-game</p>
    <p>Monetary compensation for your contributions</p>
  </div>
);

const Farlight84TierExplained = () => (
  <div className={tierStyle.desc}>
    <p className={tierStyle.t2}>Farlight 84 Content Creator Tiers and Their Requirements and Perks</p>
    <p className={tierStyle.t1}>Level 1: Farlight 84 Rising Creators (FRC)</p>
    <p className={tierStyle.t1}>Requirement:</p>
    <p>- Create at least one Farlight 84-related video on a social media platform (Facebook, YouTube, Twitch, TikTok).</p>
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Earn the FRC role on the Creator Zone Discord Server.</p>
    <p>- Get a chance to win Diamond rewards through FRC Tasks, including a Monthly Cash Reward Event.</p>
    <p>- Gain access to the Farlight 84 arts and assets media pack.</p>
    <p>- Connect and share experiences with fellow FRC members.</p>
    <p>&nbsp;</p>
    <p className={tierStyle.t1}>Level 2: Farlight 84 Content Creators (FCC)</p>
    <p className={tierStyle.t1}>Requirement:</p>
    <p>- Have more than 2,000 subscribers/followers on a social media platform.</p>
    <p>- Create at least one Farlight 84-related content piece.</p>
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Attain the FCC role on the Creator Zone Discord Server.</p>
    <p>- Win Diamond rewards through FCC Tasks, including a Monthly Cash Reward Event.</p>
    <p>- Access the Farlight 84 arts and assets media pack.</p>
    <p>- Receive an exclusive FCC in-game Avatar Frame.</p>
    <p>- Gain early access to the Farlight 84 Vanguard Test Server APK.</p>
    <p>- Earn monthly rewards based on your views.</p>
    <p>- Have a chance to be promoted by official channels.</p>
    <p>&nbsp;</p>
    <p className={tierStyle.t1}>Level 3: Farlight 84 Star Creators (FSC)</p>
    <p className={tierStyle.t1}>Requirements:</p>
    <p>- Followers ≥ 2,000</p>
    <p>- Meeting the requirements on any platform is sufficient or Business Order member</p>
    <Fl84TierTable />
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Receive an in-game Avatar Frame (Star CC).</p>
    <p>- Get 2 gift pack codes per month (gold coins999, diamonds20).</p>
    <p>- Gain access to the Star CC exclusive profile background and border.</p>
    <p>- Participate in 3rd-party Tournaments (Diamonds + Room cards).</p>
    <p>- Gain V badge.</p>
    <p>- Monthly business order cooperation opportunities.</p>
    <p>&nbsp;</p>
    <p className={tierStyle.t1}>Advanced Star Creators</p>
    <p className={tierStyle.t1}>Requirements:</p>
    <p>- Have 500,000+ subscribers.</p>
    <p>- Produce at least 1 Farlight 84-related video.</p>
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Receive an additional 5,000 diamond subsidies per month.</p>
    <p>- Enjoy all the rights and benefits of Star CC Basic.</p>
    <p>&nbsp;</p>
    <p className={tierStyle.t1}>Super Star Creators</p>
    <p className={tierStyle.t1}>Requirements:</p>
    <p>- Have 1 million+ subscribers OR members of Farlight 84 Ambassadors.</p>
    <p>- Produce at least 1 Farlight 84-related video.</p>
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Receive an exclusive sticker</p>
    <p>- Get 3 gift pack codes per month (gold coins999, diamonds20).</p>
    <p>- Follow and interact with official media.</p>
    <p>- Be given priority for official cash cooperation as a contact candidate.</p>
    <p>- Enjoy all the rights and benefits of Star CC Advanced.</p>
    <p>&nbsp;</p>
    <p className={tierStyle.t1}>Farlight 84 Ambassadors</p>
    <p>Requirements:</p>
    <p>- Outstanding performers in monthly business order.</p>
    <p className={tierStyle.t1}>Perks:</p>
    <p>- Cash cooperation opportunities for a long time.</p>
    <p>- Enjoy all the rights and benefits of Super Star CC.</p>
  </div>
);

const ROKTierExplained = () => (
  <div className={tierStyle.desc}>
    <p className={tierStyle.t1}>How do we determine tiers?</p>
    <p>We take into account several factors when determining tiers for our content creators, including metrics like average views in recent periods, video complete rate, active subscriber count, editing skills, knowledge, presentation abilities, community reputation, professionalism, and cooperation and helpfulness on ROK projects, etc. </p>
    <p className={tierStyle.t1}>Apprentice Tier</p>
    <p>- Verified Contributor Role on RoK official Discord server</p>
    <p>- Access to an exclusive Discord channel for promoting your content</p>
    <p>- Access to official RoK art assets</p>
    <p>- Entry eligibility for the RoK Annual Creator Award, with the chance to win exclusive RoK souvenirs</p>
    <p>- Opportunities to receive in-game rewards</p>
    <p className={tierStyle.t1}>Associate Tier</p>
    <p>- All benefits of the Apprentice tier</p>
    <p>- Potential to be featured on official RoK social media channels under Creator Spotlights </p>
    <p>- Dedicated 1-on-1 support and prioritized feedback to game developers</p>
    <p>- Collaboration opportunities with the RoK Team to co-create content</p>
    <p>- Chances to receive in-game rewards and/or monetary compensation</p>
    <p className={tierStyle.t1}>Partner Tier</p>
    <p>- All benefits of the previous tiers</p>
    <p>- Exclusive previews of upcoming updates</p>
    <p>- Monetary compensation tailored to your impact and contributions</p>
    <p>- Priority to participating in special events including Osiris League Official Livestreams, player meetups, and offline events for content creators.</p>
  </div>
);

// 收益解释
const explainedList = {
  warpath: <WarpathExplained />,
  dislyte: <DislyteExplained />,
  COD: <CODExplained />,
  farlight84: <Farlight84Explained />,
  rok: <ROKExplained />
};

// 星级描述
const tierExplainedList = {
  warpath: <WarpathTierExplained />,
  dislyte: <DislyteTierExplained />,
  COD: <CODTierExplained />,
  farlight84: <Farlight84TierExplained />,
  rok: <ROKTierExplained />
};

// discord链接
const discordLink = {
  dislyte: "https://discord.gg/d4uR3F6bUa",
  warpath: "https://discord.gg/uRKdbZukku",
  COD: "https://discord.gg/KNzDdjwTHk",
  farlight84: "https://discord.gg/9xPvwkrVSm",
  rok: "https://discord.gg/7tDSxUeEQJ"
};

// 游戏icon
const gameIcons = {
  warpath,
  dislyte,
  afk,
  afk2,
  igame: afk2,
  aoc,
  rok,
  COD,
  farlight84
};

// 收入提示
const earningTip = {
  dislyte: [
    "In-game and montary benefits will be distributed through the following channels.",
    "1. In-game rewards: Directly mailed through in-game.",
    "2. Cash: Bank transfer to your provided bank account.",
    "3. CDK: Currently CDKs are not offered as rewards to Creators."
  ],
  warpath: [
    "1. In-game rewards: Directly mailed through in-game",
    "*If creators have any questions on the rewards, ",
    "they can feel free to check with the mod in charge for further clarification",
    "2. Cash: International wires to bank accounts",
    "(i.e. Contracted signed in advance for legitimacy)",
    "3. CDK: Content Ops Team will be responsible for finalizing the list of qualified creators, ",
    "submitting the application to the devs team and aligning the gift codes with these qualfied creators"
  ],
  COD: [
    "How do we determine tiers?",
    "We take into account several factors when determining tiers for our content creators, including things ",
    "like average views in recent period, subscriber count, editing skills, knowledge, presentation abilities, ",
    "community likability, professionalism, and cooperation and helpfulness on Call of Dragons projects. ",
  ],
  farlight84: [
    "Reward Explanation",
    "<br />",
    "Submission Requirements",
    "<span>1. </span>Video works must remain public.",
    "<span>2. </span>The title must include the keyword: Farlight 84. Video descriptions need to include #farlight84 #fcc #farlight84fcc.",
    "<span>3. </span>Content must be related to the Farlight 84 game.",
    "<br />",
    "Weekly Reward Settlement Criteria",
    "<span>1. </span>Only creators who reach the FCC level are eligible for weekly diamond rewards based on their play counts. (Calculation is based on reaching the FCC standard level on settlement day; rewards will not be retroactively given for previous works.)",
    "<span>2. </span>Weekly video views count rewards are calculated separately for each platform.",
    "<span>3. </span>Weekly reward criteria (YouTube, Facebook, Twitch):",
    "<span> </span>Views reach 250, receive 150 diamonds.",
    "<span> </span>Views Reach 1,000, Receive 450 Diamonds.",
    "<span> </span>Views Reach 2,000, Receive 650 Diamonds.",
    "<span> </span>Views Reach 3,000, Receive 750 Diamonds.",
    "<span> </span>Views Reach 4,000, Receive 850 Diamonds.",
    "<span> </span>Views Reach 5,000, Receive 950 Diamonds.",
    "<span> </span>Views Reach 6,000, Receive 1,050 Diamonds.",
    "<span> </span>Views Reach 7,000, Receive 1,250 Diamonds.",
    "<span> </span>Views Reach 10,000, Receive 1,450 Diamonds.",
    "<span> </span>Views Reach 20,000, Receive 1,650 Diamonds.",
    "<span> </span>Views Reach 50,000, Receive 2,000 Diamonds.",
    "<span> </span>Views Reach 100,000, Receive 2,500 Diamonds.",
    "4. Weekly reward criteria (TikTok):",
    "<span> </span>Views reach 250, receive 100 diamonds.",
    "<span> </span>Views Reach 1,000, Receive 350 Diamonds.",
    "<span> </span>Views Reach 2,000, Receive 500 Diamonds.",
    "<span> </span>Views Reach 3,000, Receive 600 Diamonds.",
    "<span> </span>Views Reach 4,000, Receive 700 Diamonds.",
    "<span> </span>Views Reach 5,000, Receive 800 Diamonds.",
    "<span> </span>Views Reach 6,000, Receive 900 Diamonds.",
    "<span> </span>Views Reach 7,000, Receive 1,000 Diamonds.",
    "<span> </span>Views Reach 10,000, Receive 1,200 Diamonds.",
    "<span> </span>Views Reach 20,000, Receive 1,400 Diamonds.",
    "<span> </span>Views Reach 50,000, Receive 1,800 Diamonds.",
    "<span> </span>Views Reach 125,000, Receive 2,200 Diamonds.",
    "<span> </span>Weekly views data will be counted and settled twice. The first settlement is on the next Wednesday and rewards will be distributed on every Friday. The second settlement is counted and settled again four weeks later on Wednesday, ensuring the final views for each video are as accurate as possible.",
    "<span> </span>...",
    "<br />",
    "Note",
    "<span>1. </span>Data fetching might be delayed by 1-2 days. If complete data for the week is not available, it will be calculated in the subsequent four-week settlement's additional data.",
    "<span>2. </span>If the published videos for the current week are not submitted before the following Wednesday, they will be included in the four-week settlement's additional data. Creators should ensure timely submissions; missing the settlement deadline will result in no reward distribution.",
    "<span>3. </span>If your UID has not been verified, rewards will not be distributed. Once UID verification is completed, rewards will be distributed retroactively.",
    "<span>4. </span>Usage of any tools/methods for promotion or boosting is not allowed. Any violation will result in blacklisting and loss of creator status.",
    "<span> </span>...",
    "<br />",
    "Example",
    "Chance is a Farlight 84 creator with 2000 followers on both his YouTube and TikTok, making him an FCC. He has correctly verified his UID. Chance is eligible for weekly views count rewards.",
    "Settlement Period: Videos published between July 31st and August 6th.",
    "Settlement Date: August 9th.",
    "Chance - YouTube views: 5000, TikTok views: 8000. On August 11th, he can receive 950 + 1000 diamonds, totaling 1950 diamonds.",
    "Settlement Date: September 6th.",
    "Chance - YouTube views: 8000, TikTok views: 30000. On September 8th, he can receive 1250 + 1400 - 1950, totaling 700 diamonds.",
    "Therefore, Chance's videos published between July 31st and August 6th can earn a total of 1950+700=2650 diamonds."
  ],
  rok: [
    "1. In-game rewards: Directly mailed through in-game or sent through discord with a giftcode.",
    "*If creators have any questions on the rewards,",
    "they can feel free to check with the mod in charge for further clarification",
    "2. Cash: International wires to bank accounts",
    "(i.e. Contracted signed in advance for legitimacy)",
    "Monthly earnings may differ from case to case. To get more information or clarification, kindly reach out to the relevant community manager.",
  ]
};

// 注册页额外申请链接
const ExtraApplyEn = () => {
  return (
    <p>
      *If you don&apos;t meet the above requirements, <br />
      please submit your application <a target="_blank" rel="noreferrer" onClick={() => { window.gtag("event", "en_extra_sign"); }} href="https://forms.gle/ePxxm2g2RWvmtYUb6">here</a>
    </p>
  );
};

export const defaultRegionData = {
  explainedList,
  tierExplainedList,
  discordLink,
  gameIcons,
  earningTip
};

export const regionStoreEn = {
  extraApplyLink: <ExtraApplyEn />,
  extraSingUpRule: [<span key="exRule1Eng">An English video content creator on any of the following platforms (Youtube, Twitch, Tiktok)</span>],
  region: "en"
};